module.exports = "/images/vendor/flag-icon-css/flags/4x3/lr.svg?309ccbd814f8f4ab23dd5a3116f9f2ac";